import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.update();
    this.onResize = () => this.update();
    window.addEventListener('resize', this.onResize);
  }

  disconnect() {
    window.removeEventListener('resize', this.onResize);
  }

  update() {
    if (window.innerWidth >= 1024) {
      this.element.setAttribute('open', '');
    } else {
      this.element.removeAttribute('open');
    }
  }
}
